"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _flowbiteReact = require("flowbite-react");
var _goLogo = _interopRequireDefault(require("../icons/go-logo.svg"));
var _customModal = _interopRequireDefault(require("./custom-modal"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Header = _ref => {
  let {
    absolute,
    logo,
    btnHref,
    btnText,
    modal,
    modalBtnName,
    modalTitle,
    modalDesc,
    actionBtnHref,
    actionBtn
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: ` ${absolute ? "absolute top-0 left-0 right-0" : ""} px-2 lg:px-12 header`,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "container",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_flowbiteReact.Navbar, {
        fluid: true,
        rounded: true,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_flowbiteReact.Navbar.Brand, {
          href: "/",
          className: !modal ? "port:m-auto" : "",
          children: logo !== undefined && logo !== "" ? logo : /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
            alt: "logo",
            src: _goLogo.default,
            className: "w-[194.11px] h-[23.38px]"
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: `md:order-2 md:flex sm:ml-auto ${!modal ? "hidden" : ""}`,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: "flex md:order-2",
            children: modal ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_customModal.default, {
              modalBtnName: modalBtnName,
              modalTitle: modalTitle,
              modalDesc: modalDesc,
              actionBtnHref: actionBtnHref,
              actionBtn: actionBtn
            }) : btnText ? /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
              href: btnHref,
              className: "secondary-btn-sml inline-flex items-center",
              children: btnText
            }) : ""
          })
        })]
      })
    })
  });
};
var _default = Header;
exports.default = _default;